<i *ngIf="isKeyAscOrder()" class="fa fa-sort-asc" aria-hidden="true"></i>
<i *ngIf="isKeyDescOrder()" class="fa fa-caret-down" aria-hidden="true"></i>